export default __webpack_public_path__ + "static/media/spooky_hill_s1.26ff7f89.png";